import React, { PropTypes }   from 'react';
import { get }                from 'lodash';
import cx                     from 'classnames';
import TrackingActions        from 'actions/tracking_actions';
import HasSliderEvents        from 'mixins/has_slider_events';
import HasPercentageWidth     from 'mixins/has_percentage_width';
import IOSVideoSetCurrentTime from 'mixins/ios_video_set_current_time';
import PlayerDragBar          from 'components/player/drag_bar';

export default React.createClass({
  displayName: 'Player.ProgressBar',
  propTypes: {
     currentTime: PropTypes.number,
        duration: PropTypes.number,
       isLoading: PropTypes.bool,
     isBuffering: PropTypes.bool,
       hasLength: PropTypes.bool,
        hasScrub: PropTypes.bool,
     hasProgress: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    bufferredEnd: PropTypes.number,
            meta: PropTypes.object
  },
  mixins: [ HasSliderEvents, HasPercentageWidth, IOSVideoSetCurrentTime ],
  getDefaultProps() {
    return {
        hasLength: true,
         hasScrub: true,
      hasProgress: true
    };
  },
  getInitialState() {
    return {
      isDragging: false
    };
  },
  componentDidMount() { },
  shouldComponentUpdate(nextProps) {
    if(this.props.currentTime === nextProps.currentTime) {
      return true;
    }
    if(this.props.bufferredEnd !== nextProps.bufferredEnd) {
      return true;
    }
    if(nextProps.event === 'ready') {
      return true;
    }
    if(typeof nextProps.currentTime === 'undefined') {
      return false;
    }
    if(typeof nextProps.duration === 'undefined') {
      return false;
    }
    if(nextProps.isBuffering !== this.props.isBuffering || nextProps.isLoading !== this.props.isLoading) {
      return true;
    }
    const delta = nextProps.currentTime - this.props.currentTime;
    return nextProps.duration !== this.props.duration || Math.abs(delta) > 0.005;
  },
  seek(e) {
    if(!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
      return;
    }
    const seekTo = this.getSliderValueX(e, this.props.duration, this.props.isFullScreen, document.querySelector('.video-player-controls-wrap'));
    TrackingActions.scrub();
    if(this.seekTime !== seekTo) {
      this.setCurrentTime(seekTo);
    }
    this.seekTime = seekTo;
  },
  dragStart(e) {
    if(this.props.hasScrub && !document.getElementById('tvPlayer').classList.contains('presistant-video')) {
      this.refs.dragBar.dragStart(e);
    }
  },
  render() {
    const duration    = this.props.duration,
          currentTime = this.props.currentTime,
          style       = this.getStyle(currentTime, duration, this.props.isFullScreen),
          loadedStyle = this.getStyle(this.props.bufferredEnd, duration, this.props.isFullScreen),
          wrapStyle   = cx({
                          'video-player-progress-bar-wrap': true,
                                               'grabbable': this.props.hasScrub,
                                        'is-advertisement': get(this, 'props.meta.isAdvertisement', false)
                        });
    // NB: the drag bar is just there to make the user feel
    // good. seek happens when the mouseup bubbles to the outter div
    let dragBar;
    if(this.props.hasProgress) {
      dragBar = (<PlayerDragBar ref="dragBar"
                                className="video-player-elapsed-time-indicator"
                                hasScrub={this.props.hasScrub}
                                currentTime={this.props.currentTime}
                                duration={this.props.duration}
                                isFullScreen={this.props.isFullScreen}
                                style={style}
                                isDragging={this.state.isDragging}
                                onDragEnd={this.seek} />);
    }
    return (
      <div className={wrapStyle}
          onMouseUp={this.seek}
          onTouchEnd={this.seek}
          onMouseDown={this.dragStart}
          onTouchStart={this.dragStart} >
        <div className="video-player-loaded-bar" style={loadedStyle}>
        </div>
        { dragBar }
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/player/progress_bar.jsx
 **/